import {combineReducers} from 'redux'
import {get} from 'lodash'
import types from 'actions/types'
import {createPivotTableReducer} from 'reducers/pivotTable'
import {getPivotTableTotalReducer} from "helpers/pivotTable"

export const companyId = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_NOT_INVOICED_UPDATE_FILTERS:
      return get(action, 'filters.companyId', state)
    case types.CONTACTS_RECENTS_REMOVE:
      return state && state === action.companyId ? null : state
    case types.CONTACTS_RECENTS_CLEAR:
      return null  // not necessarily correct, but best guess
    default:
      return state
  }
}

export const timeKey = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_NOT_INVOICED_UPDATE_FILTERS:
      return get(action, 'filters.timeKey', state)
    default:
      return state
  }
}

export const dateTypes = (state = [], action) => {
  switch (action.type) {
    case types.INVOICING_NOT_INVOICED_UPDATE_FILTERS:
      return get(action, 'filters.dateTypes', state)
    default:
      return state
  }
}

export const targetStart = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_NOT_INVOICED_UPDATE_FILTERS:
      return get(action, 'filters.targetStart', state)
    default:
      return state
  }
}

export const targetEnd = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_NOT_INVOICED_UPDATE_FILTERS:
      return get(action, 'filters.targetEnd', state)
    default:
      return state
  }
}

export const estimatorId = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_NOT_INVOICED_UPDATE_FILTERS:
      return get(action, 'filters.estimatorId', state)
    default:
      return state
  }
}

export const salesPersonId = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_NOT_INVOICED_UPDATE_FILTERS:
      return get(action, 'filters.salesPersonId', state)
    default:
      return state
  }
}

export const selectedRoles = (state = [], action) => {
  switch (action.type) {
    case types.INVOICING_NOT_INVOICED_UPDATE_FILTERS:
      return get(action, 'filters.selectedRoles', state)
    default:
      return state
  }
}

export const selectedContacts = (state = [], action) => {
  switch (action.type) {
    case types.INVOICING_NOT_INVOICED_UPDATE_FILTERS:
      return get(action, 'filters.selectedContacts', state)
    default:
      return state
  }
}

export const orderTypeId = (state = [], action) => {
  switch (action.type) {
    case types.INVOICING_NOT_INVOICED_UPDATE_FILTERS:
      return get(action, 'filters.orderTypeId', state)
    default:
      return state
  }
}

export const status = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_NOT_INVOICED_UPDATE_FILTERS:
      return get(action, 'filters.status', state)
    default:
      return state
  }
}

const total = (state = null, action) => {
  return getPivotTableTotalReducer(state, action, deliveredNotInvoicedPivotTableKey)
}

export const deliveredNotInvoicedPivotTableKey = 'invoicingContext.notInvoiced.pivotTable'

export default combineReducers({
  pivotTable: createPivotTableReducer({key: deliveredNotInvoicedPivotTableKey, defaultSortColumn: 'desc'}),
  companyId,
  timeKey,
  dateTypes,
  targetStart,
  targetEnd,
  estimatorId,
  salesPersonId,
  selectedRoles,
  selectedContacts,
  orderTypeId,
  status,
  total,
})
